module.exports = {
  primaryDark: '#CA3239',
  error: '#762F36',
  darkAlizarin: '#DD1B23',
  alizarin: '#E73941',
  primary: '#F05B62',
  blushFlame: '#F0576A',
  primaryLight: '#F37B81',
  pink: '#F9BDC0',
  lightPink: '#FFF3F4',

  tomThumb: '#445A3E',
  darkGreen: '#3B684F',
  mostlyGreen: '#48785D',
  secondaryDark: '#88AD7B',
  freshMint: '#99BE8C',
  secondary: '#9EC392',
  secondaryLight: '#B1CFA7',
  gardenMist: '#DFE7D6',
  aquaSpring: '#E7F1E5',
  aquaSpringLight: '#F1F7EF',
  success: '#398500',
  brightGreen: '#039520',
  kiwiLeafLight: '#A6D989',
  oliveAsh: '#B5B6AB',

  tertiaryDark: '#5D908C',
  tertiary: '#85CFC9',
  tertiaryLight: '#9DD8D3',
  navyBlue: '#4267B2',
  info: '#1859D6',
  outline: '#4D90FE',
  blue: '#25BCCA',

  warning: '#EB8900',
  honeyAmber: '#F59300',
  sunsetGold: '#FD8E06',
  yellow: '#FFCC5A',
  warningLight: '#FFEBCE',
  linen: '#F9F5F0',

  ivoryBlack: '#231F20',
  shark: '#303338',
  charcoalBlack: '#3C3C3C',
  charcoal: '#444444',
  davyGrey: '#555555',
  steelGrey: '#666666',
  ashGrey: '#7E8082',
  avatarBorderGrey: '#979797',
  osloGrey: '#97999B',
  silverDust: '#AAAAAA',
  cloudGrey: '#BBBBBB',
  silver: '#C0C0C0',
  fogGrey: '#CFCFCF',
  iron: '#D7D7D8',
  superSilver: '#EEEEEE',
  alabaster: '#F4F3EF',
  pearlWhite: '#F5F5F5',
  frostWhite: '#F9F9F9',
  white: '#FFFFFF',

  // new colors
  limeBright: '#C5D800',
  limeBrightHover: '#D1E500',
  forestDeep: '#08441B',
  forestDeepHover: '#285D2E',
  forestDeepDarker: '#063517',
  lavenderSoft: '#E1A8F8',
  lavenderSoftHover: '#E0BCF6',
  wineRich: '#762F36',
  wineRichHover: '#993D46',
  cream: '#E9CEB2',
  espresso: '#30261E',
  lavenderPale: '#EBD5F9',
  limePale: '#F3F2B2',
  peachPale: '#F7E6D6',
  peach: '#E5B597',
  limeFresh: '#EAEE76',
  lavenderBright: '#D8AAF3',
  terracotta: '#CB6C2F'
}
